import { Box, Checkbox } from '@primer/react';
import { useEffect, useState } from 'react';
import { dangKyAnApi } from '../../../api/dangKyAn';
import DataTable from '../../../components/ui/data-table';
import { NotifyHelper } from '../../../helpers/toast';
import { IBanTruResponse } from '../../../models/response/crm-hocsinh/IBanTruResponse';

export interface BanTruProps {
    ts_hocsinh_id: number;
    canEdit?: boolean;
}

const BanTruPage = (props: BanTruProps) => {
    const { canEdit = true } = props;
    const [banTrus, setBanTrus] = useState<IBanTruResponse[]>([]);
    const [caAns, setCaAns] = useState<any>();
    const [columns, setColumns] = useState<any>([]);
    useEffect(() => {
        handleGetBanTruData();
    }, [props.ts_hocsinh_id]);

    const handleGetBanTruData = async () => {
        const res = await dangKyAnApi.selectByHocSinh(props.ts_hocsinh_id);
        if (res.is_success) {
            setBanTrus(res.data);
            if (res.data && res.data.length > 0)
                await getCaAnTruong(res.data[0]?.dm_truong_id || 0, res.data);
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }
    };

    const getCaAnTruong = async (dm_truong_id: number, dataBanTrus: IBanTruResponse[]) => {
        const res = await dangKyAnApi.selectCaAnByTruong(dm_truong_id);
        if (res.is_success) {
            const column = [
                {
                    dataField: "dot_dang_ky",
                    width: "auto",
                    caption: `Đợt đăng ký`,
                    isMainColumn: true
                }
            ];
            const newColumns = res.data.map((item: any) => ({
                id: crypto.randomUUID(),
                caption: item.ten_ca,
                width: "auto",
                cellRender: (data: any) => {
                    return (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                            }}
                        >
                            <Checkbox
                                    checked={checkData(item.id, dataBanTrus)}
                                    disabled={!canEdit}
                                />
                        </Box>
                    );
                },
            }));
            setColumns([...column, ...newColumns]);
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }
    };

    const checkData = (id: number, dataBanTrus: IBanTruResponse[]) => {
        return dataBanTrus.find(x => x.fo_caan_id == id) ? true : false;
    }

    return (
        <Box sx={{ padding: 0 }}>
            <Box sx={{ display: "flex", gap: 3 }}>
                <Box sx={{ flex: 1 }}>
                    <DataTable
                        height={`${window.innerHeight - 200}px`}
                        actionComponent={
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 2,
                                }}
                            >

                            </Box>
                        }
                        columns={columns}
                        data={banTrus}
                        title="Thông tin đăng ký ăn bán trú"
                        searchEnable
                    />
                </Box>
                <Box sx={{ flex: 1 }} >
                    <Box
                        sx={{
                            border: "1px solid",
                            borderColor: "border.default",
                            borderRadius: 2,
                            maxHeight: "calc(100vh - 420px)",
                            overflowY: "auto",
                        }}
                    >
                        <Box
                            sx={{
                                bg: "canvas.subtle",
                                p: 2,
                                borderBottom: "1px solid",
                                borderColor: "border.default",
                                fontWeight: "bold",
                                color: "fg.muted",
                            }}
                        >
                            Danh sách điểm danh ăn hàng ngày
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BanTruPage;
